import React from "react";

function FooterItem (props: any) {
    return (
        <div className={props.activeIconName !== props.name ? 'footer-item': "footer-item is-selected"} onClick={props.func}>
            <img src={props.icon} alt="icon" width='30' height='30'/>
            <div className='footer-item_name'>
                {props.name}
            </div>
        </div>
    )
}

export default FooterItem